import React from 'react';

import { ClickType } from '../../../sharedModules/getClickType';
import { getWidgetInitialiser } from '../../../sharedModules/getWidgetInitialiser';
import { LegacyEventType } from '../../../types/LegacyEventType';
import { loadCSS } from '../../../utils/loadCSS';
import { WidgetResult } from '../../hooks/useAnalytics';
import { GetInitializerPropsParams, InitialiserProps } from '../../types/InitialiserProps';
import type { WidgetProps } from '../../types/WidgetProps';

import SeasonalLinkItem from './SeasonalLinkItem';

loadCSS('seasonal');

type SeasonalProps = {
  sendAnalytics: WidgetProps['sendAnalytics'];
  dealData: WidgetProps['dealData'];
  seasonalResponse: WidgetProps['seasonalResponse'];
  genericSharedComponents: WidgetProps['genericSharedComponents'];
  result: WidgetProps['result'];
};

export const Seasonal: React.FC<SeasonalProps> = (props) => {
  const {
    genericSharedComponents: { HawkWidgetProvider },
    sendAnalytics,
    seasonalResponse,
    dealData,
    result,
  } = props;

  const clickLink = (): void => {
    if (seasonalResponse.ok && seasonalResponse.data.link) {
      sendAnalytics({
        event: {
          category: 'Navigation',
          label: seasonalResponse.data.link.link_text,
          clickType: ClickType.DEALS_PAGE,
          type: LegacyEventType.CLICK_FROM,
        },
        product: {
          url: seasonalResponse.data.link.url,
        },
        dealData,
      });
    }
  };

  if (result === WidgetResult.MISSING) {
    return null;
  }

  return (
    <HawkWidgetProvider {...props}>
      <SeasonalLinkItem clickLink={clickLink} />
    </HawkWidgetProvider>
  );
};

Seasonal.getInitialiserProps = ({
  renderProps,
  attributes,
  getWidgetResponse,
  getModelOffersResponse,
  getSeasonalResponse,
  getAiredaleFeeds,
  getModelSuggestions,
  postForWidgetResponse,
  editorial,
  defaultParams,
  origin,
  dataLinkMerchant,
}: GetInitializerPropsParams): InitialiserProps => {
  // Get the initialiser for the widget & render it when the initialiser resolves
  return getWidgetInitialiser({
    editorial,
    defaultParams,
    origin,
    dataLinkMerchant,
    getWidgetResponse,
    getModelOffersResponse,
    getSeasonalResponse,
    getAiredaleFeeds,
    getModelSuggestions,
    postForWidgetResponse,
    attributes,
    ...renderProps,
  });
};

export default Seasonal;
